module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "height": "100vh",
      "width": "100vw",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }) : (!_vm.availableCountries.some(function (country) { return country.codCountry === 'AR'; })) ? _c('div', [_c('error404')], 1) : _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión: Retención Ganancias",
      "visible": _vm.showModalCertificationExgain,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationExgain = false
      }
    }
  }, [(this.certificationExgain[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Período fiscal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].period))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Resolución:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].resolution))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationExgain[0].publication) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].validity))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationExgain
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: Retención Ganancias",
      "visible": _vm.showModalCertificationsExgainList,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationsExgainList = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationExgainList), function(item) {
    return _c('tr', {
      key: item.IdCertificationExGain
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.publication))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.validity))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationExgain(item.IdCertificationExGain)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsExgainList
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exención: RG2681",
      "visible": _vm.showModalCertificationRg2681,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg2681 = false
      }
    }
  }, [(this.certificationRg2681[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Tipo de sujeto:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Cod. Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Desc. Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].stateDescription) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Emisión del Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].emision))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha Adm. Formal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].administrationDate) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Autoriza Deducción:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].auth))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Obligado Pres. DDJJ:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].ddjj))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Código Inciso:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].subsection))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Vigencia desde:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Vigencia hasta:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].until))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Por orden judicial:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].orderJud))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha última modificación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].modificationDate) + "\n              ")])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg2681
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Datos adicionales del certificado",
      "visible": _vm.showModalCertificationDatosAdicionales,
      "width": "30%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationDatosAdicionales = false
      }
    }
  }, [(_vm.taxData.jurisdictions[_vm.activeJurisdiction]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Seleccionar"
    },
    model: {
      value: (_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificateFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData.jurisdictions[_vm.activeJurisdiction], "certificateFrom", $$v)
      },
      expression: "taxData.jurisdictions[activeJurisdiction].certificateFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "type": "date",
      "placeholder": "Seleccionar"
    },
    model: {
      value: (_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificateTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData.jurisdictions[_vm.activeJurisdiction], "certificateTo", $$v)
      },
      expression: "taxData.jurisdictions[activeJurisdiction].certificateTo"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-upload', {
    ref: 'jurisdictions\[' + _vm.jurId + '\]\[\'certificatePdf\'\]',
    staticClass: "upload-demo",
    attrs: {
      "id": "uploadCertificatePdf",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdfCertificate,
      "on-exceed": _vm.handleExceed,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            Solo se permiten archivos PDF\n          ")])], 1), _vm._v(" "), _c('span', [(_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificatePdf) ? _c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.taxData.jurisdictions[_vm.activeJurisdiction].certificatePdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n          ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalCertificationDatosAdicionales = false
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Formulario 1276",
      "visible": _vm.showModalForm1276,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalForm1276 = false
      }
    }
  }, [(_vm.taxData.jurisdictions[_vm.activeJurisdiction]) ? _c('div', [_c('div', [_c('el-upload', {
    ref: 'jurisdictions\[' + _vm.jurId + '\]\[\'form1276pdf\'\]',
    staticClass: "upload-demo",
    attrs: {
      "id": "uploadForm1276",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdfForm1276,
      "on-exceed": _vm.handleExceed,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            Solo se permiten archivos PDF\n          ")])], 1), _vm._v(" "), _c('span', [(_vm.taxData.jurisdictions[_vm.activeJurisdiction].form1276pdf) ? _c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.taxData.jurisdictions[_vm.activeJurisdiction].form1276pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n          ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalForm1276 = false
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveJurisdiction.apply(null, arguments)
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exención: RG2681",
      "visible": _vm.showModalCertificationRg2681List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg2681List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg2681List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG2681
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.emision))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg2681(item.idCertificationRG2681)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg2681List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión: Retención SUSS",
      "visible": _vm.showModalCertificationSuss,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationSuss = false
      }
    }
  }, [(this.certificationSuss[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Período fiscal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].period))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Resolución:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].resolution))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationSuss
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: SUSS",
      "visible": _vm.showModalCertificationSussList,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationSussList = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationSussList), function(item) {
    return _c('tr', {
      key: item.idCertificaction
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationSuss(item.idCertificaction)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsSussList
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de agente de retención RG18: Retención I.V.A",
      "visible": _vm.showModalCertificationRg18,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg18 = false
      }
    }
  }, [(this.certificationRg18[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Razón Social:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("INCISO RG:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg18
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de agente de retención: RG18",
      "visible": _vm.showModalCertificationRg18List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg18List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "150px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg18List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG18
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg18(item.idCertificationRG18)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg18List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión RG17: Retención I.V.A",
      "visible": _vm.showModalCertificationRg17,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg17 = false
      }
    }
  }, [(this.certificationRg17[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Razón Social:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("INCISO RG:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].rg))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Tipo de Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg17
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: RG17",
      "visible": _vm.showModalCertificationRg17List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg17List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "150px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg17List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG17
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg17(item.idCertificationRG17)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg17List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Confirmar Alta de Proveedor",
      "visible": _vm.terminosYCondVisible,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.terminosYCondVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('div', [_vm._v("\n        ¿Usted, la sociedad, algún accionista, funcionario, Director, agente, afiliado o empleado clave de su Compañía es PEP, empleado o está asociado actualmente a un Funcionario Público?\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "10px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "size": "small",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.associatedPEP),
      callback: function($$v) {
        _vm.associatedPEP = $$v
      },
      expression: "associatedPEP"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("\n          ¿Interactuará usted o, en caso de corresponder, su Compañía con una entidad gubernamental en nombre de cualquiera de las empresas del Grupo Albanesi?\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "40px",
      "margin-top": "15px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "size": "small",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.govInteraction),
      callback: function($$v) {
        _vm.govInteraction = $$v
      },
      expression: "govInteraction"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v("\n        Acepto el\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("Código de Ética y Conducta")]), _vm._v(".\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v("\n        Acepto las políticas:\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaAnticorrupcion
    }
  }, [_vm._v("Política Anticorrupción")]), _vm._v("\n        y\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaRelacionamiento
    }
  }, [_vm._v("Política de Relacionamiento con Funcionarios Públicos.")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    staticStyle: {
      "position": "relative",
      "left": "45%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("\n          Aceptar\n        ")])])])]), _vm._v(" "), (!_vm.paramError && !_vm.provider) ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("\n    SOLICITAR SER PROVEEDOR\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.paramError && !_vm.provider) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n    Complete el formulario\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "transition": "all 1s",
      "margin-right": "30px",
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  }), _vm._v("\n      Volver\n    ")])], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.paramError))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('el-steps', {
    attrs: {
      "active": _vm.step,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Datos Generales"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Bancarios"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Impositivos"
    }
  }), _vm._v(" "), (!_vm.provider) ? _c('el-step', {
    attrs: {
      "title": "Usuario"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.paramError) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(_vm.step === 0) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos Generales")]) : _vm._e(), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(_vm.step === 0) ? _c('h5', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "-3%"
    }
  }, [_vm._v("\n                Ultima modificación: " + _vm._s(_vm.provider.generalData.modifDate) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos de Pago")]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos Impositivos")]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuario")]) : _vm._e()]), _vm._v(" "), (
    _vm.user &&
    _vm.user.isProvider &&
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('el-alert', {
    attrs: {
      "title": "Etapa en verificacion",
      "type": "warning",
      "description": "Los datos de esta etapa estan siendo verificados.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (
    (_vm.user &&
      _vm.user.isProvider &&
      _vm.provider &&
      _vm.provider[_vm.activeTab()].idCompanyDataStatus === _vm.status.ACEPTADO) ||
    (_vm.user &&
      !_vm.user.isProvider &&
      _vm.provider &&
      _vm.provider[_vm.activeTab()].idCompanyDataStatus === _vm.status.ESPERANDO_CONFIRMACION)
  ) ? _c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.editing) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("Editar")]) : _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), (_vm.editing === true) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.cancelData
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.providerLoaded && this.user && this.idCompany),
      expression: "!providerLoaded && this.user && this.idCompany"
    }],
    staticClass: "box-body"
  }, [_c('el-col', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    }
  }, [(_vm.provider && false) ? _c('el-row', {
    staticStyle: {
      "height": "90px",
      "padding-top": "20px",
      "text-align": "right"
    }
  }, [_c('el-tag', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "effect": "dark",
      "type": _vm.statusType
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.getStatusNameOfTab()) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 0) ? _c('el-form', {
    ref: "generalDataForm",
    attrs: {
      "model": _vm.generalData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesGeneralData,
      "label-position": _vm.currentLabelPosition,
      "label-width": "25%",
      "id": "formDatosGenerales"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "info-box-content"
  }, [_c('p', {
    staticClass: "text-danger alta-text"
  }, [_vm._v("\n                    Los campos acompañados con asterisco(*) son obligatorios.\n                  ")])]), _vm._v(" "), _c('el-divider', [_vm._v("Datos de la empresa.")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CUIT (sin guiones)",
      "prop": "cuit"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "id": "cuit",
      "type": "text",
      "maxlength": "11",
      "show-word-limit": "",
      "disabled": _vm.dataAfip !== ''
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.cuit, 'cuit')
      }
    },
    model: {
      value: (_vm.generalData.cuit),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "cuit", _vm._n($$v))
      },
      expression: "generalData.cuit"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16,
      "align": "center"
    }
  }, [(!_vm.dataAfip) ? _c('el-button', {
    attrs: {
      "id": "verificarAFIP",
      "size": "mini",
      "disabled": _vm.generalData.cuit.toString().length !== 11,
      "type": "primary"
    },
    on: {
      "click": _vm.verifyCuit
    }
  }, [_vm._v("\n                      Verificar AFIP\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.dataAfip && !this.provider) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": _vm.editCuit
    }
  }, [_vm._v("\n                      Editar\n                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataAfip),
      expression: "dataAfip"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "Razón Social / Denominación",
      "prop": "company"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "xs": 23,
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "255",
      "data-cy": "input-company"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.company, 'company')
      }
    },
    model: {
      value: (_vm.generalData.company),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "company", $$v)
      },
      expression: "generalData.company"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre de Fantasía",
      "prop": "companyName"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "255",
      "data-cy": "input-fantasyName"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.companyName, 'companyName')
      }
    },
    model: {
      value: (_vm.generalData.companyName),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "companyName", $$v)
      },
      expression: "generalData.companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Fecha de inicio de Actividades",
      "prop": "start_date"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Inicio de Actividades"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.start_date, 'start_date')
      }
    },
    model: {
      value: (_vm.generalData.start_date),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "start_date", $$v)
      },
      expression: "generalData.start_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "¿En qué central prestará el servicio?",
      "prop": "centrales"
    }
  }, [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-select', {
    attrs: {
      "id": "centrales",
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.centrales, 'centrales')
      }
    },
    model: {
      value: (_vm.generalData.centrales),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "centrales", $$v)
      },
      expression: "generalData.centrales"
    }
  }, _vm._l((_vm.centrales), function(item) {
    return _c('el-option', {
      key: item.idCentral,
      attrs: {
        "label": item.central,
        "value": item.idCentral
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Servicio / Actividad",
      "prop": "rubros"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-rubros"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.rubros, 'rubros')
      }
    },
    model: {
      value: (_vm.generalData.rubros),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "rubros", $$v)
      },
      expression: "generalData.rubros"
    }
  }, _vm._l((_vm.services), function(item) {
    return _c('el-option', {
      key: item.idRubro,
      attrs: {
        "label": item.nombre,
        "value": item.idRubro
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "Calle",
      "prop": "address"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 19,
      "xs": 19
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-address"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.address, 'address')
      }
    },
    model: {
      value: (_vm.generalData.address),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "address", $$v)
      },
      expression: "generalData.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "xs": 12
    }
  }, [_c('el-form-item', {
    staticClass: "alta-input",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "label": "Nº",
      "prop": "addressNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "200",
      "data-cy": "input-addressNumber"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.addressNumber, 'addressNumber')
      }
    },
    model: {
      value: (_vm.generalData.addressNumber),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "addressNumber", $$v)
      },
      expression: "generalData.addressNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    (_vm.provider.generalData.address !=
      _vm.provider.logCompanyGeneralData.address ||
      _vm.provider.generalData.addressNumber !=
      _vm.provider.logCompanyGeneralData
      .addressNumber)
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Código Postal",
      "prop": "zipCode"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "type": "text",
      "maxlength": "20",
      "data-cy": "input-zipCode"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.zipCode, 'zipCode')
      }
    },
    model: {
      value: (_vm.generalData.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "zipCode", $$v)
      },
      expression: "generalData.zipCode"
    }
  })], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.zipCode !=
    _vm.provider.logCompanyGeneralData.zipCode
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "País",
      "prop": "idCountry"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "country",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-country"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.idCountry, 'idCountry')
      },
      "change": _vm.updateProvinces
    },
    model: {
      value: (_vm.generalData.idCountry),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "idCountry", $$v)
      },
      expression: "generalData.idCountry"
    }
  }, _vm._l((_vm.countries), function(item) {
    return _c('el-option', {
      key: item.idCountry,
      attrs: {
        "label": item.country,
        "value": item.idCountry
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.idCountry !=
    _vm.provider.logCompanyGeneralData.idCountry
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Provincia",
      "prop": "idProvince"
    }
  }, [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "state",
      "disabled": _vm.generalData.idCountry === '',
      "filterable": "",
      "clearable": "",
      "data-cy": "input-province"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.idProvince, 'idProvince')
      }
    },
    model: {
      value: (_vm.generalData.idProvince),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "idProvince", $$v)
      },
      expression: "generalData.idProvince"
    }
  }, _vm._l((_vm.provinces), function(item) {
    return _c('el-option', {
      key: item.idProvince,
      attrs: {
        "label": item.province,
        "value": item.idProvince
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.idProvince !=
    _vm.provider.logCompanyGeneralData.idProvince
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ciudad",
      "prop": "city"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "data-cy": "input-city",
      "maxlength": "100"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.city, 'city')
      }
    },
    model: {
      value: (_vm.generalData.city),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "city", $$v)
      },
      expression: "generalData.city"
    }
  })], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.city !=
    _vm.provider.logCompanyGeneralData.city
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail aviso de Pago",
      "prop": "paymentEmail"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-paymentEmail"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.paymentEmail, 'paymentEmail')
      }
    },
    model: {
      value: (_vm.generalData.paymentEmail),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "paymentEmail", $$v)
      },
      expression: "generalData.paymentEmail"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.paymentEmail !=
    _vm.provider.logCompanyGeneralData.paymentEmail
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail aviso de Recepción",
      "prop": "receiptEmail"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-receiptEmail"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.receiptEmail, 'receiptEmail')
      }
    },
    model: {
      value: (_vm.generalData.receiptEmail),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "receiptEmail", $$v)
      },
      expression: "generalData.receiptEmail"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.receiptEmail !=
    _vm.provider.logCompanyGeneralData.receiptEmail
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sujeto IVA",
      "prop": "typeIVA"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "sujeto",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-typeIVA"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.typeIVA, 'typeIVA')
      }
    },
    model: {
      value: (_vm.generalData.typeIVA),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "typeIVA", $$v)
      },
      expression: "generalData.typeIVA"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "IVA Responsable Inscripto",
      "value": "01"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA Responsable no Inscripto",
      "value": "02"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA No Responsable",
      "value": "03"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA Sujeto a exención",
      "value": "04"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA consumidor final",
      "value": "05"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Responsable Monotributo Bienes",
      "value": "06"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Responsable Monotributo Servicios",
      "value": "006"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Sujeto no Categorizado",
      "value": "07"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Proveedor del exterior",
      "value": "08"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.typeIVA !=
    _vm.provider.logCompanyGeneralData.typeIVA
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Persona",
      "prop": "personType"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "persona",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-personType"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.personType, 'personType')
      },
      "change": function($event) {
        _vm.generalData.personSubType = ''
      }
    },
    model: {
      value: (_vm.generalData.personType),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personType", $$v)
      },
      expression: "generalData.personType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Física",
      "value": "Física"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Jurídica",
      "value": "Jurídica"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personType !=
    _vm.provider.logCompanyGeneralData.personType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.generalData.personType === 'Jurídica') ? _c('el-form-item', {
    staticClass: "select-alta",
    attrs: {
      "label": "Subtipo",
      "prop": "personSubType"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "data-cy": "input-personSubType"
    },
    on: {
      "change": function($event) {
        _vm.generalData.personSubTypeOther = ''
      },
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.personSubType, 'personSubType')
      }
    },
    model: {
      value: (_vm.generalData.personSubType),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personSubType", $$v)
      },
      expression: "generalData.personSubType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "S.A.",
      "value": "S.A."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "S.R.L.",
      "value": "S.R.L."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "S.H.",
      "value": "S.H."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Otro",
      "value": "Otro"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personSubType !=
    _vm.provider.logCompanyGeneralData.personSubType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.generalData.personSubType === 'Otro') ? _c('el-form-item', [_c('el-form-item', {
    attrs: {
      "label": "Otro subtipo",
      "prop": "personSubTypeOther"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.personSubTypeOther),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personSubTypeOther", $$v)
      },
      expression: "generalData.personSubTypeOther"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personSubTypeOther !=
    _vm.provider.logCompanyGeneralData
    .personSubTypeOther
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                Campo\n                                "), _vm._v("modificado\n                              ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.generalData.pdfAfip,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Alta en AFIP actualizada a la fecha",
      "id": "altadeAfip",
      "prop": "pdfAfip"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.generalData, "pdfAfip", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.generalData, "pdfAfip", $event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Contacto principal")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre",
      "prop": "namePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-namePrincipalContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.namePrincipalContact, 'namePrincipalContact')
      }
    },
    model: {
      value: (_vm.generalData.namePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "namePrincipalContact", $$v)
      },
      expression: "generalData.namePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.namePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .namePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Apellido",
      "prop": "surnamePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-surnamePrincipalContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.surnamePrincipalContact, 'surnamePrincipalContact')
      }
    },
    model: {
      value: (_vm.generalData.surnamePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "surnamePrincipalContact", $$v)
      },
      expression: "generalData.surnamePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.surnamePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .surnamePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Teléfono",
      "prop": "phonePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-phonePrincipalContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.phonePrincipalContact, 'phonePrincipalContact')
      }
    },
    model: {
      value: (_vm.generalData.phonePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "phonePrincipalContact", $$v)
      },
      expression: "generalData.phonePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.phonePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .phonePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail",
      "prop": "emailPrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-emailPrincipalContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.emailPrincipalContact, 'emailPrincipalContact')
      }
    },
    model: {
      value: (_vm.generalData.emailPrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "emailPrincipalContact", $$v)
      },
      expression: "generalData.emailPrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.emailPrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .emailPrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Contacto comercial")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre",
      "prop": "nameCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-nameCommercialContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.nameCommercialContact, 'nameCommercialContact')
      }
    },
    model: {
      value: (_vm.generalData.nameCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "nameCommercialContact", $$v)
      },
      expression: "generalData.nameCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.nameCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .nameCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Apellido",
      "prop": "surnameCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-surnameCommercialContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.surnameCommercialContact, 'surnameCommercialContact')
      }
    },
    model: {
      value: (_vm.generalData.surnameCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "surnameCommercialContact", $$v)
      },
      expression: "generalData.surnameCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.surnameCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .surnameCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Teléfono",
      "prop": "phoneCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-phoneCommercialContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.phoneCommercialContact, 'phoneCommercialContact')
      }
    },
    model: {
      value: (_vm.generalData.phoneCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "phoneCommercialContact", $$v)
      },
      expression: "generalData.phoneCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.phoneCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .phoneCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail",
      "prop": "emailCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-emailCommercialContact"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.emailCommercialContact, 'emailCommercialContact')
      }
    },
    model: {
      value: (_vm.generalData.emailCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "emailCommercialContact", $$v)
      },
      expression: "generalData.emailCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.emailCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .emailCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('br')], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('el-form', {
    ref: "paymentDataForm",
    attrs: {
      "model": _vm.paymentData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesPaymentData,
      "label-position": _vm.currentLabelPosition,
      "label-width": "25%",
      "id": "formDatosPagos"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(false) ? _c('div', [_c('el-divider', [_vm._v("Cheque")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sucursal de retiro",
      "prop": "idBankBranch"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.paymentData.idBankBranch),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBankBranch", $$v)
      },
      expression: "paymentData.idBankBranch"
    }
  }, _vm._l((_vm.bankBranches), function(item) {
    return _c('el-option', {
      key: item.idBankBranch,
      attrs: {
        "label": item.bankBranch,
        "value": item.idBankBranch
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBankBranch !=
    _vm.provider.logCompanyPaymentData.idBankBranch
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("Transferencia")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Banco",
      "prop": "idBank"
    }
  }, [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "bank",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-idBank"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.paymentData.idBank, 'idBank')
      }
    },
    model: {
      value: (_vm.paymentData.idBank),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBank", $$v)
      },
      expression: "paymentData.idBank"
    }
  }, _vm._l((_vm.banks), function(item) {
    return _c('el-option', {
      key: item.idBank,
      attrs: {
        "label": item.bank,
        "value": item.idBank
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBank !=
    _vm.provider.logCompanyPaymentData.idBank
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select-alta",
    attrs: {
      "label": "Tipo de cuenta",
      "prop": "idBankAccountType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "accounttype",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-idBankAccountType"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.paymentData.idBankAccountType, 'idBankAccountType')
      }
    },
    model: {
      value: (_vm.paymentData.idBankAccountType),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBankAccountType", $$v)
      },
      expression: "paymentData.idBankAccountType"
    }
  }, _vm._l((_vm.accountTypes), function(item) {
    return _c('el-option', {
      key: item.idBankAccountType,
      attrs: {
        "label": item.bankAccountType,
        "value": item.idBankAccountType
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBankAccountType !=
    _vm.provider.logCompanyPaymentData.idBankAccountType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nro. de cuenta",
      "prop": "accountNumber"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "id": "accountnumber",
      "maxlength": "50",
      "data-cy": "input-accountNumber"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.paymentData.accountNumber, 'accountNumber')
      }
    },
    model: {
      value: (_vm.paymentData.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "accountNumber", $$v)
      },
      expression: "paymentData.accountNumber"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.accountNumber !=
    _vm.provider.logCompanyPaymentData.accountNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nro. CBU",
      "prop": "cbu"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "id": "nrocbu",
      "maxlength": "22",
      "show-word-limit": "",
      "data-cy": "input-cbu"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.paymentData.cbu, 'cbu')
      }
    },
    model: {
      value: (_vm.paymentData.cbu),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "cbu", $$v)
      },
      expression: "paymentData.cbu"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.cbu !=
    _vm.provider.logCompanyPaymentData.cbu
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.paymentData.pdfBank,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Constancia",
      "id": "formPdfBank",
      "prop": "pdfBank"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.paymentData, "pdfBank", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.paymentData, "pdfBank", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesTaxData,
      "label-position": _vm.currentLabelPosition,
      "label-width": "25%",
      "id": "formDatosImpositivosIb"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-divider', [_vm._v("Ingresos Brutos")]), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfIb,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Constancia IB actualizada a la fecha",
      "id": "formIB",
      "prop": "pdfIb"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfIb", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfIb", $event)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "ibType"
    }
  }, [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "typeib",
      "clearable": "",
      "data-cy": "input-typeib"
    },
    on: {
      "change": _vm.handleIbType,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ibType, 'ibType')
      }
    },
    model: {
      value: (_vm.taxData.ibType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ibType", $$v)
      },
      expression: "taxData.ibType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Multilateral",
      "value": "Multilateral"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Local",
      "value": "Local"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Exento",
      "value": "Exento"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ibType !=
    _vm.provider.logCompanyTaxData.ibType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.taxData.ibType === 'Exento') ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfsExempt,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Constancia de exento",
      "id": "uploadConstanciaExcento",
      "prop": "pdfsExempt"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfsExempt", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfsExempt", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('el-form-item', {
    attrs: {
      "label": "Regimen de convenio",
      "prop": "idAgreementRegimeType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenConvenio",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-idAgreementRegimeType"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.idAgreementRegimeType, 'idAgreementRegimeType')
      }
    },
    model: {
      value: (_vm.taxData.idAgreementRegimeType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "idAgreementRegimeType", $$v)
      },
      expression: "taxData.idAgreementRegimeType"
    }
  }, _vm._l((_vm.regimenTypes), function(item) {
    return _c('el-option', {
      key: item.idAgreementRegimeType,
      attrs: {
        "label": item.agreementRegimeType,
        "value": item.idAgreementRegimeType
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.idAgreementRegimeType !=
    _vm.provider.logCompanyTaxData.idAgreementRegimeType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfCM05,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* CM05",
      "id": "uploadPdfCM05",
      "prop": "pdfCM05"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfCM05", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfCM05", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jurisdicciones) ? _c('el-form-item', {
    attrs: {
      "label": "Jurisdicción sede",
      "prop": "jurisdictionHeadquarters"
    }
  }, [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "jsede",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-jurisdictionHeadquarters"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.jurisdictionHeadquarters, 'jurisdictionHeadquarters')
      }
    },
    model: {
      value: (_vm.taxData.jurisdictionHeadquarters),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "jurisdictionHeadquarters", $$v)
      },
      expression: "taxData.jurisdictionHeadquarters"
    }
  }, _vm._l((_vm.jurisdictions), function(item) {
    return _c('el-option', {
      key: item.idJurisdictions,
      attrs: {
        "label": item.jurisdictions,
        "value": item.idJurisdictions
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.jurisdictionHeadquarters !=
    _vm.provider.logCompanyTaxData.jurisdictionHeadquarters
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "jurisdictions"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [(this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "padding-right": "45px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Jurisdicción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n                      Jurisdicción\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" Alicuota** ")]), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "padding-right": "45px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Coef. Unificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-right": "1%"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n                      Coef. Unificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      N° de Certificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "margin-right": "40px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      N° de Certificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "margin-left": "-50px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Datos adicionales\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Datos adicionales\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Agente de Retención\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "45px",
      "line-height": "30px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Agente de Retención\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Agente de Percepción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "50px",
      "line-height": "30px"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Agente de Percepción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "80px"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("Formulario 1276\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _vm._l((_vm.taxData.jurisdictions), function(jurisdict, jurId) {
    return _c('el-row', {
      key: jurId,
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "15px"
      },
      attrs: {
        "align": "center",
        "type": "flex",
        "justify": "center",
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'idJurisdiction\\'\\]'"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "95%"
      },
      attrs: {
        "filterable": "",
        "clearable": ""
      },
      on: {
        "input": _vm.saveJurisdiction,
        "change": function($event) {
          return _vm.changeAlicoutJurisdiction(
            jurisdict.idJurisdiction,
            jurId
          )
        }
      },
      model: {
        value: (jurisdict.idJurisdiction),
        callback: function($$v) {
          _vm.$set(jurisdict, "idJurisdiction", $$v)
        },
        expression: "jurisdict.idJurisdiction"
      }
    }, _vm._l((_vm.jurisdictionsHabilitadas), function(item) {
      return _c('el-option', {
        key: item.idJurisdictions,
        attrs: {
          "label": item.jurisdictions,
          "value": item.idJurisdictions
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [(!_vm.isAlicuotList(jurisdict.idJurisdiction, jurId)) ? _c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'aliquot\\'\\]'",
        "rules": [{
            required: _vm.isSantaFe(jurisdict.idJurisdiction),
            message: 'Campo obligatorio',
            trigger: 'change',
          },
          {
            trigger: 'change'
          } ]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (jurisdict.aliquota_value),
        callback: function($$v) {
          _vm.$set(jurisdict, "aliquota_value", _vm._n($$v))
        },
        expression: "jurisdict.aliquota_value"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAlicuotList(jurisdict.idJurisdiction, jurId)) ? _c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'aliquot\\'\\]'",
        "rules": [{
            required: _vm.isSantaFe(jurisdict.idJurisdiction),
            message: 'Campo obligatorio',
            trigger: 'change',
          },
          {
            trigger: 'change'
          } ]
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "filterable": "",
        "clearable": ""
      },
      model: {
        value: (jurisdict.aliquot),
        callback: function($$v) {
          _vm.$set(jurisdict, "aliquot", $$v)
        },
        expression: "jurisdict.aliquot"
      }
    }, _vm._l((_vm.retentionCategoriesAliquot), function(item) {
      return _c('el-option', {
        key: item.idCategoryRetain,
        attrs: {
          "label": item.categoryRetain,
          "value": item.idCategoryRetain
        }
      })
    }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' + jurId + '\]\[\'coefficient\'\]'
      }
    }, [_c('el-input', {
      on: {
        "input": function($event) {
          return _vm.validateCoefficient($event, jurId)
        }
      },
      model: {
        value: (jurisdict.coefficient),
        callback: function($$v) {
          _vm.$set(jurisdict, "coefficient", $$v)
        },
        expression: "jurisdict.coefficient"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateNumber\'\]'
      }
    }, [_c('el-input', {
      on: {
        "input": _vm.saveJurisdiction
      },
      model: {
        value: (jurisdict.certificateNumber),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateNumber", $$v)
        },
        expression: "jurisdict.certificateNumber"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "disabled": !jurisdict.certificateNumber
      },
      on: {
        "click": function($event) {
          return _vm.openModalCertificateDetails(jurId)
        }
      }
    }, [_vm._v("\n                        Editar\n                      ")]), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": "Datos adicionales del certificado",
        "visible": jurisdict.certficateDetailsVisible,
        "width": "40%"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-form-item', {
      attrs: {
        "label": "Desde",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateFrom\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.certificateFrom),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateFrom", $$v)
        },
        expression: "jurisdict.certificateFrom"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Hasta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateTo\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.certificateTo),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateTo", $$v)
        },
        expression: "jurisdict.certificateTo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificatePdf\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'certificatePdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfCertificate,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.certificatePdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.certificatePdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.certficateDetailsVisible = false
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentHas\'\]'
      }
    }, [_c('el-switch', {
      attrs: {
        "active-text": "Si",
        "inactive-text": "No",
        "active-value": "1",
        "inactive-value": "0"
      },
      on: {
        "change": function($event) {
          return _vm.openModalRetentionAgent(jurId)
        },
        "input": _vm.saveJurisdiction
      },
      model: {
        value: (jurisdict.retentionAgentHas),
        callback: function($$v) {
          _vm.$set(jurisdict, "retentionAgentHas", $$v)
        },
        expression: "jurisdict.retentionAgentHas"
      }
    }), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "success",
        "size": "small",
        "circle": "",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.openModalRetentionAgent(jurId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentDate\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-dialog', {
      attrs: {
        "title": "Agente de retención.",
        "visible": jurisdict.retentionAgentVisible,
        "width": "40%",
        "before-close": function () { return (jurisdict.retentionAgentHas = '0'); }
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Fecha de alta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentDate\'\]'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      on: {
        "input": _vm.saveJurisdiction
      },
      model: {
        value: (jurisdict.retentionAgentDate),
        callback: function($$v) {
          _vm.$set(jurisdict, "retentionAgentDate", $$v)
        },
        expression: "jurisdict.retentionAgentDate"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'retentionAgentPdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfRetentionAgent,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.retentionAgentPdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.retentionAgentPdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.retentionAgentVisible = false
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveJurisdiction.apply(null, arguments)
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentHas\'\]'
      }
    }, [_c('el-col', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "span": 25
      }
    }, [_c('el-switch', {
      attrs: {
        "active-text": "Si",
        "inactive-text": "No",
        "active-value": "1",
        "inactive-value": "0"
      },
      on: {
        "change": function($event) {
          return _vm.openModalPerceptionAgent(jurId)
        }
      },
      model: {
        value: (jurisdict.perceptionAgentHas),
        callback: function($$v) {
          _vm.$set(jurisdict, "perceptionAgentHas", $$v)
        },
        expression: "jurisdict.perceptionAgentHas"
      }
    })], 1), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "success",
        "size": "small",
        "circle": "",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.openModalPerceptionAgent(jurId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentDate\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-dialog', {
      attrs: {
        "title": "Agente de percepción.",
        "visible": jurisdict.perceptionAgentVisible,
        "width": "40%",
        "before-close": function () { return (jurisdict.perceptionAgentHas = '0'); }
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Fecha de alta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentDate\'\]'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.perceptionAgentDate),
        callback: function($$v) {
          _vm.$set(jurisdict, "perceptionAgentDate", $$v)
        },
        expression: "jurisdict.perceptionAgentDate"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentPdf\'\]'
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'perceptionAgentPdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfPerceptionAgent,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.perceptionAgentPdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.perceptionAgentPdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.perceptionAgentVisible = false
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveJurisdiction.apply(null, arguments)
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (jurisdict.idJurisdiction === '13') ? _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form', {
      attrs: {
        "disabledData": false
      }
    }, [_c('el-button', {
      staticStyle: {
        "font-size": "10px"
      },
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.openModalForm1276(jurId)
        }
      }
    }, [_vm._v("\n                          Seleccionar archivo\n                        ")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' + jurId + '\]\[\'form1276pdf\'\]',
        "rules": [{
          required: true,
          message: 'Constancia obligatoria',
          trigger: 'change',
        } ]
      }
    }), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": "Formulario 1276",
        "visible": jurisdict.form1276Visible,
        "width": "40%"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-form-item', {
      attrs: {
        "label": "Formulario 1276",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'form1276pdf\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'form1276pdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfForm1276,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.form1276pdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.form1276pdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.form1276Visible = false
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveJurisdiction.apply(null, arguments)
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)) ? _c('el-form-item', {
      staticStyle: {
        "width": "250px",
        "margin-right": "-250px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (jurisdict.agentDontOperateHere),
        expression: "jurisdict.agentDontOperateHere"
      }],
      staticStyle: {
        "width": "15px",
        "float": "left",
        "cursor": "pointer",
        "margin-right": "25px",
        "margin-top": "13px"
      },
      attrs: {
        "type": "checkbox",
        "name": "operaAqui",
        "required": ""
      },
      domProps: {
        "checked": Array.isArray(jurisdict.agentDontOperateHere) ? _vm._i(jurisdict.agentDontOperateHere, null) > -1 : (jurisdict.agentDontOperateHere)
      },
      on: {
        "change": function($event) {
          var $$a = jurisdict.agentDontOperateHere,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(jurisdict, "agentDontOperateHere", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(jurisdict, "agentDontOperateHere", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(jurisdict, "agentDontOperateHere", $$c)
          }
        }
      }
    }), _c('span', {
      staticStyle: {
        "margin-left": "-70px",
        "margin-top": "15px"
      }
    }, [_vm._v("No Presta Servicio aqui")])]) : _vm._e(), _vm._v(" "), (!['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction) && jurisdict.idJurisdiction !== '13') ? _c('el-col', {
      staticStyle: {
        "margin-left": "-80px"
      },
      attrs: {
        "span": 3
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)) ? _c('el-col', {
      staticStyle: {
        "float": "right",
        "margin-right": "-250px"
      },
      attrs: {
        "span": 5,
        "offset": 2
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (jurisdict.idJurisdiction === '13') ? _c('el-col', {
      staticStyle: {
        "margin-left": "-25px"
      },
      attrs: {
        "span": 3
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.addJurisdiction()
      }
    }
  }, [_vm._v("Agregar jurisdicción")]) : _vm._e()], 2), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("** Alicuota a aplicar por el agente de retención")]), _vm._v(" "), _c('el-divider', [_vm._v("Retención Ganancias")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "earningsRetentionType"
    }
  }, [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "typeGanancias",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.earningsRetentionType, 'earningsRetentionType')
      }
    },
    model: {
      value: (_vm.taxData.earningsRetentionType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsRetentionType", $$v)
      },
      expression: "taxData.earningsRetentionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Inscripto",
      "value": "Inscripto"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Exento",
      "value": "Exento"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsRetentionType !=
    _vm.provider.logCompanyTaxData.earningsRetentionType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.earningsRetentionType === 'Inscripto' &&
    _vm.generalData.typeIVA !== '06'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen de Retención",
      "prop": "retentionRegimen"
    }
  }, [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "retencion",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateRetentionCategory,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.retentionRegimen, 'retentionRegimen')
      }
    },
    model: {
      value: (_vm.taxData.retentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "retentionRegimen", $$v)
      },
      expression: "taxData.retentionRegimen"
    }
  }, _vm._l((_vm.retentionRegimes), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.retentionRegimen !=
    _vm.provider.logCompanyTaxData.retentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.taxData.earningsRetentionType === 'Inscripto' &&
    _vm.generalData.typeIVA === '06'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen de Retención",
      "prop": "retentionRegimen"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateRetentionCategory,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.retentionRegimen, 'retentionRegimen')
      }
    },
    model: {
      value: (_vm.taxData.retentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "retentionRegimen", $$v)
      },
      expression: "taxData.retentionRegimen"
    }
  }, _vm._l((_vm.retentionRegimeList), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.retentionRegimen !=
    _vm.provider.logCompanyTaxData.retentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsRetentionType === 'Inscripto') ? _c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "idEarningCategoryRetain"
    }
  }, [_c('el-col', {
    staticClass: "select-alta",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaR",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.idEarningCategoryRetain, 'idEarningCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.idEarningCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "idEarningCategoryRetain", $$v)
      },
      expression: "taxData.idEarningCategoryRetain"
    }
  }, _vm._l((_vm.retentionCategories2), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.idEarningCategoryRetain !=
    _vm.provider.logCompanyTaxData.idEarningCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión Retención Ganancias")]), _vm._v(" "), (_vm.provider && _vm.provider.certifExgain.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationExgainList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión Retención Ganancias")]), _vm._v(" "), (this.certificationExgainList.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationExgainList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exención RG2681")]), _vm._v(" "), (_vm.provider && _vm.provider.certifRg2681.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg2681List()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('br'), _c('br')])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exención RG2681")]), _vm._v(" "), (this.certificationRg2681List.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg2681List()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('br'), _c('br')])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'earningsExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.earningsExclusionNumber, 'earningsExclusionNumber')
      }
    },
    model: {
      value: (_vm.taxData.earningsExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionNumber", $$v)
      },
      expression: "taxData.earningsExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'earningsExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.earningsExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.earningsExclusionFrom, 'earningsExclusionFrom')
      }
    },
    model: {
      value: (_vm.taxData.earningsExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionFrom", $$v)
      },
      expression: "taxData.earningsExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'earningsExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.earningsExclusionNumber,
      "picker-options": _vm.disabledDates,
      "type": "date",
      "placeholder": "Hasta"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.earningsExclusionTo, 'earningsExclusionTo')
      }
    },
    model: {
      value: (_vm.taxData.earningsExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionTo", $$v)
      },
      expression: "taxData.earningsExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionNumber !=
    _vm.provider.logCompanyTaxData.earningsExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionFrom !=
    _vm.provider.logCompanyTaxData.earningsExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionTo !=
    _vm.provider.logCompanyTaxData.earningsExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.earningsExclusionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Certificado exclusión",
      "id": "uploadPdfearningsExclusion",
      "prop": "earningsExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "earningsExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "earningsExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifExgain.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationExgainList.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()]), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifRg2681.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationRg2681List.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Retención SUSS")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Empleador",
      "prop": 'sussEmployeer'
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "inactive-text": "No",
      "active-value": "1",
      "inactive-value": "0"
    },
    on: {
      "change": function($event) {
        _vm.taxData.sussEmployeer ?
          (_vm.taxData.sussRetentionRegimen =
            _vm.taxData.sussEmployeer) :
          _vm.taxData.sussEmployeer
      }
    },
    model: {
      value: (_vm.taxData.sussEmployeer),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussEmployeer", $$v)
      },
      expression: "taxData.sussEmployeer"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussEmployeer !=
    _vm.provider.logCompanyTaxData.sussEmployeer
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Agente de retención",
      "prop": 'retentionRegime'
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": _vm.taxData.sussEmployeer === '0',
      "enabled": _vm.taxData.sussEmployeer === '1',
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "Si",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.taxData.sussRetentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussRetentionRegimen", $$v)
      },
      expression: "taxData.sussRetentionRegimen"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussRetentionRegimen !=
    _vm.provider.logCompanyTaxData.sussRetentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.sussEmployeer &&
    _vm.taxData.sussRetentionRegimen === '1'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen a retener",
      "prop": "sussIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussIdCategoryRetain, 'sussIdCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.sussIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussIdCategoryRetain", $$v)
      },
      expression: "taxData.sussIdCategoryRetain"
    }
  }, _vm._l((_vm.sussRetentionCategory), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.sussIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.taxData.sussEmployeer == '1' &&
    _vm.taxData.sussRetentionRegimen == '0'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen a retener",
      "prop": "sussIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussIdCategoryRetain, 'sussIdCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.sussIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussIdCategoryRetain", $$v)
      },
      expression: "taxData.sussIdCategoryRetain"
    }
  }, _vm._l((_vm.sussRetentionCategory), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.sussIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (_vm.provider && _vm.provider.certifSuss.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationSussList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (this.certificationSussList.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationSussList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'sussExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "30"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussExclusionNumber, 'sussExclusionNumber')
      }
    },
    model: {
      value: (_vm.taxData.sussExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionNumber", $$v)
      },
      expression: "taxData.sussExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'sussExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.sussExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussExclusionFrom, 'sussExclusionFrom')
      }
    },
    model: {
      value: (_vm.taxData.sussExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionFrom", $$v)
      },
      expression: "taxData.sussExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'sussExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "disabled": !_vm.taxData.sussExclusionNumber,
      "type": "date",
      "placeholder": "Hasta"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussExclusionTo, 'sussExclusionTo')
      }
    },
    model: {
      value: (_vm.taxData.sussExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionTo", $$v)
      },
      expression: "taxData.sussExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussExclusionNumber !=
    _vm.provider.logCompanyTaxData.sussExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussExclusionFrom !=
    _vm.provider.logCompanyTaxData.sussExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionTo !=
    _vm.provider.logCompanyTaxData.sussExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.sussExclusionPdf,
      "habModificaPdf": !!_vm.taxData.sussExclusionNumber,
      "titulo": "* Exclusión",
      "id": "uploadPdfExclusion",
      "prop": "sussExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "sussExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "sussExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifSuss.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationSussList.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Retención I.V.A.")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "label": "¿Es agente de retención?",
      "prop": 'ivaRetentionAgent'
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "inactive-text": "No",
      "active-value": "1",
      "inactive-value": "0"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaRetentionAgent, 'ivaRetentionAgent')
      }
    },
    model: {
      value: (_vm.taxData.ivaRetentionAgent),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaRetentionAgent", $$v)
      },
      expression: "taxData.ivaRetentionAgent"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaRetentionAgent !=
    _vm.provider.logCompanyTaxData.ivaRetentionAgent
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', {
    staticStyle: {
      "padding-left": "25%"
    }
  }, [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [(_vm.provider && _vm.provider.certifRg18.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg18List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-tag', {
    staticStyle: {
      "margin-left": "0%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [(this.certificationRg18List.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg18List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-tag', {
    staticStyle: {
      "margin-left": "0%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.ivaRetentionAgent &&
    _vm.taxData.ivaRetentionAgent !== '1'
  ) ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaResolutionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Resolución",
      "id": "uploadPdfResolucion",
      "prop": "sussExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivos",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataIvaResolutionPdf
    }
  }, [(
    _vm.taxData.ivaRetentionAgent &&
    _vm.taxData.ivaRetentionAgent === '1'
  ) ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaResolutionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Resolución",
      "id": "ivaResolutionPdf",
      "prop": "ivaResolutionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Régimen de retención",
      "prop": "ivaIdRetentionRegime"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenRetencion",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateIvaRetentionCategory,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaIdRetentionRegime, 'ivaIdRetentionRegime')
      }
    },
    model: {
      value: (_vm.taxData.ivaIdRetentionRegime),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaIdRetentionRegime", $$v)
      },
      expression: "taxData.ivaIdRetentionRegime"
    }
  }, _vm._l((_vm.retentionRegimesVAT), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaIdRetentionRegime !=
    _vm.provider.logCompanyTaxData.ivaIdRetentionRegime
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "ivaIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaRetener",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaIdCategoryRetain, 'ivaIdCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.ivaIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaIdCategoryRetain", $$v)
      },
      expression: "taxData.ivaIdCategoryRetain"
    }
  }, _vm._l((_vm.ivaRetentionCategories), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.ivaIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (_vm.provider && _vm.provider.certifRg17.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG17")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg17List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (this.certificationRg17List.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG17")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg17List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'ivaExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "30"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaExclusionNumber, 'ivaExclusionNumber')
      }
    },
    model: {
      value: (_vm.taxData.ivaExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionNumber", $$v)
      },
      expression: "taxData.ivaExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'ivaExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.ivaExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaExclusionFrom, 'ivaExclusionFrom')
      }
    },
    model: {
      value: (_vm.taxData.ivaExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionFrom", $$v)
      },
      expression: "taxData.ivaExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'ivaExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "disabled": !_vm.taxData.ivaExclusionNumber,
      "type": "date",
      "placeholder": "Hasta"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaExclusionTo, 'ivaExclusionTo')
      }
    },
    model: {
      value: (_vm.taxData.ivaExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionTo", $$v)
      },
      expression: "taxData.ivaExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionNumber !=
    _vm.provider.logCompanyTaxData.ivaExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionFrom !=
    _vm.provider.logCompanyTaxData.ivaExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionTo !=
    _vm.provider.logCompanyTaxData.ivaExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaExclusionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "",
      "id": "ivaExclusionPdf",
      "prop": "ivaExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifRg17.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationRg17List.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Otros impuestos")]), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivosOi",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataOtros
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Régimen de retención",
      "prop": "otrosIdRetentionRegime"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenRetencion",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateOtrosRetentionCategory,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.otrosIdRetentionRegime, 'otrosIdRetentionRegime')
      }
    },
    model: {
      value: (_vm.taxData.otrosIdRetentionRegime),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "otrosIdRetentionRegime", $$v)
      },
      expression: "taxData.otrosIdRetentionRegime"
    }
  }, _vm._l((_vm.retentionRegimesOTROS), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.otrosIdRetentionRegime !=
    _vm.provider.logCompanyTaxData.otrosIdRetentionRegime
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivosRe",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataOtros
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "otrosIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaRetener",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.otrosIdCategoryRetain, 'otrosIdCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.otrosIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "otrosIdCategoryRetain", $$v)
      },
      expression: "taxData.otrosIdCategoryRetain"
    }
  }, _vm._l((_vm.otrosRetentionCategories), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.otrosIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.otrosIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step === 3 && !_vm.provider) ? _c('el-form', {
    ref: "userDataForm",
    attrs: {
      "model": _vm.userData,
      "label-position": _vm.currentLabelPositionUser,
      "rules": _vm.rulesUserData,
      "label-width": "25%",
      "id": "formUsuario"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nombre y Apellido",
      "prop": "name",
      "rules": [{
        required: true,
        message: 'Campo obligatorio',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "data-cy": "input-userName"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.userData.name, 'name')
      }
    },
    model: {
      value: (_vm.userData.name),
      callback: function($$v) {
        _vm.$set(_vm.userData, "name", $$v)
      },
      expression: "userData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Correo electrónico",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "data-cy": "input-userEmail"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.userData.email, 'email')
      }
    },
    model: {
      value: (_vm.userData.email),
      callback: function($$v) {
        _vm.$set(_vm.userData, "email", $$v)
      },
      expression: "userData.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Contraseña",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "data-cy": "input-userPw"
    },
    model: {
      value: (_vm.userData.password),
      callback: function($$v) {
        _vm.$set(_vm.userData, "password", $$v)
      },
      expression: "userData.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Repetir contraseña",
      "prop": "passwordRe",
      "rules": [{
          pattern: _vm.userData.password,
          message: 'Las contraseñas deben coincidir',
          trigger: 'change',
        },
        {
          required: true,
          message: 'Campo obligatorio',
          trigger: '',
        } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "data-cy": "input-userPwRe"
    },
    model: {
      value: (_vm.userData.passwordRe),
      callback: function($$v) {
        _vm.$set(_vm.userData, "passwordRe", $$v)
      },
      expression: "userData.passwordRe"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION &&
    !_vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-divider', [_vm._v(" Aceptar datos ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "data-cy": "btn-rechazar"
    },
    on: {
      "click": function($event) {
        return _vm.verifyPermission()
      }
    }
  }, [_vm._v("\n                  Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "data-cy": "btn-aceptar"
    },
    on: {
      "click": function($event) {
        return _vm.acceptCompanyData()
      }
    }
  }, [_vm._v("\n                  Aceptar "), _c('i', {
    staticClass: "el-icon-check"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_vm._v("\n                  " + _vm._s(_vm.provider[_vm.activeTab()].observation) + "\n                ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.reSendCompanyData
    }
  }, [_vm._v("\n                  Volver a enviar los datos\n                ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.userByRoles ||
    (_vm.dataAfip &&
      (_vm.userIsAdmin || (_vm.user ? _vm.user.isProvider : true)))
  ) ? _c('el-button-group', [(_vm.step > 0 && !_vm.editing) ? _c('el-button', {
    attrs: {
      "data-cy": "btn-anterior",
      "type": "primary",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        return _vm.previousStep()
      }
    }
  }, [_vm._v("Anterior")]) : _vm._e(), _vm._v(" "), ((_vm.step < 2 || (_vm.step === 2 && !_vm.provider)) && !_vm.editing) ? _c('el-button', {
    attrs: {
      "data-cy": "btn-siguiente",
      "type": "primary",
      "icon": "el-icon-arrow-right"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("Siguiente")]) : _vm._e(), _vm._v(" "), (_vm.step === 3 && !_vm.provider) ? _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-check"
    },
    on: {
      "click": _vm.openModalTerminosYCond
    }
  }, [_vm._v("Confirmar")]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('div', {
    staticClass: "info-box-info"
  }, [_c('ul', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.response) + "\n                      ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container"
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese con: "), _c('b', {
    staticClass: "email__soporte"
  }, [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rechazar datos",
      "visible": _vm.rejectCompanyDataVisible,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectCompanyDataVisible = $event
      }
    }
  }, [_vm._v("\n      Escriba el motivo por el cual rechaza los datos:\n      "), _c('el-input', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": "400",
      "placeholder": "Ingrese el motivo",
      "show-word-limit": true
    },
    model: {
      value: (_vm.newObservation),
      callback: function($$v) {
        _vm.newObservation = $$v
      },
      expression: "newObservation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectCompanyData()
      }
    }
  }, [_vm._v("\n          Aceptar\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04079df6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AltaDeUsuario.vue
// module id = 611
// module chunks = 1